import { Model3dEntryStatus } from './enums/model3d-entry-status.enum';

export const model3dProcessingStatuses = [
  Model3dEntryStatus.PROCESS_STARTED,
  Model3dEntryStatus.PROCESS_PREPARING,
  Model3dEntryStatus.PROCESS_CONVERTING,
  Model3dEntryStatus.PROCESS_FINALIZING,
];

export const model3dStuckAfterMs = 3 * 24 * 60 * 60 * 1000;

export function isModel3dProcessing(entry: {
  status: Model3dEntryStatus;
  updatedAt: Date | string;
}): boolean {
  if (!model3dProcessingStatuses.includes(entry.status)) return false;

  return Date.now() - new Date(entry.updatedAt).getTime() < model3dStuckAfterMs;
}
